import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from '@material-ui/core';
import { ExpandMore, Delete } from '@material-ui/icons';
import {
  sinalizacaoHorizontalList,
  sinalizacaoVerticalList,
  alinhamentoHorizontalList,
  alinhamentoVerticalList,
  obraDeArteList,
  obrasNaPistaList,
  tipoPistaList,
  tipoPavimentoList,
  faixaSentidoList,
  condicaoPistaList,
  condicaoCalcadaList,
  separacaoCentralList,
} from '../../utils/objectsSelect';
import SubInputWarn from '../SubInputWarn';
import { formStyles } from './styles';
import AccordionDeleteWarn from '../AccordionDeleteWarn';
import { ViaObject } from '../../@types/incidentTypes';

interface IProps {
  viaObject: ViaObject;
  deleteVia: (index: number) => void;
  changeViasState: (via: ViaObject) => void;
  requiredFields: { key: string; message: string }[];
  desabilitadoViaForm?: boolean;
}

const isInList = (option: string, list: { label: string }[]): string => {
  const index = list.find((item) => item.label === option);
  return index ? option : 'Não informado';
};

const ViaForm: React.FC<IProps> = ({
  viaObject,
  deleteVia,
  changeViasState,
  requiredFields,
  desabilitadoViaForm,
}) => {
  const [viaState, setViaState] = useState<ViaObject>(viaObject);
  const [openWarn, setOpenWarn] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const classes = formStyles();

  const handleChange = (key: string, value: string) => {
    setViaState({ ...viaState, [key]: value });
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenWarn(!openWarn);
  };

  useEffect(() => {
    setViaState((prev) => {
      return {
        ...prev,
        // index: viaObject.index
        ...viaObject,
      };
    });
  }, [viaObject]);

  return (
    <div className={classes.accordionRow}>
      <Accordion style={{ marginRight: 10, marginBottom: 15 }}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography>{`Via ${viaState.index + 1}`}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item md={6} sm={12} xs={12}>
              <div className={classes.inputContainer}>
                <InputLabel
                  htmlFor={`data.driverVia[${viaState.index}].Nome`}
                  className={classes.label}
                >
                  Nome
                </InputLabel>
                <input
                  name="Nome"
                  id={`data.driverVia[${viaState.index}].Nome`}
                  className={`${classes.input} ${requiredFields.filter(
                    (item) => item.key === `NomeVia ${viaState.index}`,
                  ).length
                    ? classes.errorInput
                    : ''
                    }`}
                  onChange={(event) => handleChange('Nome', event.target.value)}
                  onBlur={() => changeViasState(viaState)}
                  value={viaState.Nome}
                  placeholder="Nome da via"
                  disabled={desabilitadoViaForm}
                />
              </div>
              <SubInputWarn
                type="error"
                formWarns={requiredFields.filter(
                  (item) => item.key === `NomeVia ${viaState.index}`,
                )}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVia[${viaState.index}].Sinalização Horizontal`}
                className={classes.label}
              >
                Sinalização Horizontal
              </InputLabel>

              <Select
                variant="outlined"
                value={isInList(
                  viaState['Sinalização Horizontal'],
                  sinalizacaoHorizontalList,
                )}
                onChange={(event) => {
                  handleChange('Sinalização Horizontal', event.target.value as string);
                }}
                onBlur={() => changeViasState(viaState)}
                className={classes.select}
                disabled={desabilitadoViaForm}
              >
                {sinalizacaoHorizontalList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVia[${viaState.index}].Sinalização Vertical`}
                className={classes.label}
              >
                Sinalização Vertical
              </InputLabel>

              <Select
                variant="outlined"
                value={isInList(
                  viaState['Sinalização Vertical'],
                  sinalizacaoVerticalList,
                )}
                onChange={(event) => {
                  handleChange('Sinalização Vertical', event.target.value as string);
                }}
                onBlur={() => changeViasState(viaState)}
                className={classes.select}
                disabled={desabilitadoViaForm}
              >
                {sinalizacaoVerticalList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVia[${viaState.index}].Alinhamento Horizontal`}
                className={classes.label}
              >
                Alinhamento Horizontal
              </InputLabel>

              <Select
                variant="outlined"
                value={isInList(
                  viaState['Alinhamento Horizontal'],
                  alinhamentoHorizontalList,
                )}
                onChange={(event) => {
                  handleChange('Alinhamento Horizontal', event.target.value as string);
                }}
                onBlur={() => changeViasState(viaState)}
                className={classes.select}
                disabled={desabilitadoViaForm}
              >
                {alinhamentoHorizontalList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVia[${viaState.index}].Alinhamento Vertical`}
                className={classes.label}
              >
                Alinhamento Vertical
              </InputLabel>

              <Select
                variant="outlined"
                value={isInList(
                  viaState['Alinhamento Vertical'],
                  alinhamentoVerticalList,
                )}
                onChange={(event) => {
                  handleChange('Alinhamento Vertical', event.target.value as string);
                }}
                onBlur={() => changeViasState(viaState)}
                className={classes.select}
                disabled={desabilitadoViaForm}
              >
                {alinhamentoVerticalList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVia[${viaState.index}].Obra de Arte`}
                className={classes.label}
              >
                Obra de Arte
              </InputLabel>

              <Select
                variant="outlined"
                value={isInList(viaState['Obra de Arte'], obraDeArteList)}
                onChange={(event) => {
                  handleChange('Obra de Arte', event.target.value as string);
                }}
                onBlur={() => changeViasState(viaState)}
                className={classes.select}
                disabled={desabilitadoViaForm}
              >
                {obraDeArteList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVia[${viaState.index}].Obras na Pista`}
                className={classes.label}
              >
                Obras na Pista
              </InputLabel>

              <Select
                variant="outlined"
                value={isInList(viaState['Obras na Pista'], obrasNaPistaList)}
                onChange={(event) => {
                  handleChange('Obras na Pista', event.target.value as string);
                }}
                onBlur={() => changeViasState(viaState)}
                className={classes.select}
                disabled={desabilitadoViaForm}
              >
                {obrasNaPistaList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVia[${viaState.index}].Tipo da Pista`}
                className={classes.label}
              >
                Tipo da Pista
              </InputLabel>

              <Select
                variant="outlined"
                // value={viaState['Tipo da Pista']}
                value={isInList(viaState['Tipo da Pista'], tipoPistaList)}
                onChange={(event) => {
                  handleChange('Tipo da Pista', event.target.value as string);
                }}
                onBlur={() => changeViasState(viaState)}
                className={classes.select}
                disabled={desabilitadoViaForm}
              >
                {tipoPistaList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVia[${viaState.index}].Tipo do Pavimento`}
                className={classes.label}
              >
                Tipo do Pavimento
              </InputLabel>

              <Select
                variant="outlined"
                value={isInList(viaState['Tipo do Pavimento'], tipoPavimentoList)}
                onChange={(event) => {
                  handleChange('Tipo do Pavimento', event.target.value as string);
                }}
                onBlur={() => changeViasState(viaState)}
                className={classes.select}
                disabled={desabilitadoViaForm}
              >
                {tipoPavimentoList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVia[${viaState.index}].Faixa para Sentido`}
                className={classes.label}
              >
                Faixa para Sentido
              </InputLabel>

              <Select
                variant="outlined"
                value={isInList(viaState['Faixa para Sentido'], faixaSentidoList)}
                onChange={(event) => {
                  handleChange('Faixa para Sentido', event.target.value as string);
                }}
                onBlur={() => changeViasState(viaState)}
                className={classes.select}
                disabled={desabilitadoViaForm}
              >
                {faixaSentidoList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVia[${viaState.index}].Condição da Pista`}
                className={classes.label}
              >
                Condição da Pista
              </InputLabel>

              <Select
                variant="outlined"
                value={isInList(viaState['Condição da Pista'], condicaoCalcadaList)}
                onChange={(event) => {
                  handleChange('Condição da Pista', event.target.value as string);
                }}
                onBlur={() => changeViasState(viaState)}
                className={classes.select}
                disabled={desabilitadoViaForm}
              >
                {condicaoPistaList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVia[${viaState.index}].Condição da Calçada`}
                className={classes.label}
              >
                Condição da Calçada
              </InputLabel>

              <Select
                variant="outlined"
                value={isInList(viaState['Condição da Calçada'], condicaoCalcadaList)}
                onChange={(event) => {
                  handleChange('Condição da Calçada', event.target.value as string);
                }}
                onBlur={() => changeViasState(viaState)}
                className={classes.select}
                disabled={desabilitadoViaForm}
              >
                {condicaoCalcadaList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVia[${viaState.index}].Separação Central`}
                className={classes.label}
              >
                Separação Central
              </InputLabel>

              <Select
                variant="outlined"
                value={isInList(viaState['Separação Central'], separacaoCentralList)}
                onChange={(event) => {
                  handleChange('Separação Central', event.target.value as string);
                }}
                onBlur={() => changeViasState(viaState)}
                className={classes.select}
                disabled={desabilitadoViaForm}
              >
                {separacaoCentralList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <IconButton
        onClick={handleClick}
        title={`Remover Via ${viaState.index + 1}`}
        disabled={desabilitadoViaForm}
      >
        <Delete />
      </IconButton>
      <AccordionDeleteWarn
        message={`Remover a Via ${viaState.index + 1}?`}
        open={openWarn}
        setOpen={setOpenWarn}
        index={viaState.index}
        anchorEl={anchorEl}
        deleteItem={() => deleteVia(viaState.index)}
      />
    </div>
  );
};

export default ViaForm;
